import Svg from '@eversports/klimt-primitives/legacy/Svg'

import LocationIcon from '../assets/location.svg'

const LocationSvg = ({ size }: { size: number }) => <Svg src={LocationIcon} width={size} height={size} />

export default LocationSvg
